<template>
  <span>
    <hmd-font v-if="value === true" :type="trueType">{{ trueText }}</hmd-font>
    <hmd-font v-if="value === false" :type="falseType">{{ falseText }}</hmd-font>
  </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "BooleanDescription",
  props: {
    value: { type: Boolean },
    trueText: { type: String, default: "启用" },
    trueType: { type: String, default: "success" },
    falseText: { type: String, default: "停用" },
    falseType: { type: String, default: "danger" },
  },
});
</script>
